import { render } from "./Footer.vue?vue&type=template&id=bd813586&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=bd813586&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=bd813586&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd813586"]])

export default __exports__